import { call, put, takeEvery } from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import * as constants from './constants';
import * as actions from './actions';

export function* getSuggestedItems(action) {
  try {
    const { data } = yield call(request, API.SEARCH_ITEMS, 'GET', {
      query: {
        query: action.payload.searchTerm,
      },
    });

    yield put(actions.getSuggestedItemsSuccess(data));
  } catch (e) {
    yield put(actions.getSuggestedItemsError(e));
  }
}

export function* getSuggestedItemsWatcher() {
  yield takeEvery(constants.GET_SUGGESTED_ITEMS, getSuggestedItems);
}
